import React, { ComponentProps } from 'react';

import { Accordion as DSAccordion } from '@zapier/design-system';

function Accordion(props: ComponentProps<typeof DSAccordion>) {
  const { children, ...rest } = props;

  return <DSAccordion {...rest}>{children}</DSAccordion>;
}

export default Accordion;
